import React, { useEffect, useState } from "react";
import { Field } from "redux-form";
import { renderTextField, renderOptionField } from "../formcomponents";
import { Button, Grid } from "semantic-ui-react";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";

const PerformaItemFieldArr = ({
  fields,
  meta: { touched, error, submitFailed },
}) => {
  const [attractionList, setAttractionList] = useState([]);

  useEffect(() => {
    if (fields.length === 0) {
      fields.push({});
    }
    getAttractionList();
  }, []);

  const getAttractionList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: 999765,
      })
      .then((res) => {
        const options = (res.data || []).map((item) => ({
          text: item.categoryName,
          value: item.categoryName,
        }));
        setAttractionList(options);
      })
      .catch((error) => console.log(error));
  };

  return (
    <>
      <Grid columns={16}>
        <Grid.Row>
          <Grid.Column width={5}>Attractions</Grid.Column>
          <Grid.Column width={2}>Non Prime Adult</Grid.Column>
          <Grid.Column width={2}>Non Prime Child</Grid.Column>
          <Grid.Column width={2}>Prime Time Adult</Grid.Column>
          <Grid.Column width={2}>Prime Time Child</Grid.Column>
          <Grid.Column width={3}>Actions</Grid.Column>
        </Grid.Row>
        {fields.map((item, index) => (
          <Grid.Row key={index}>
            <Grid.Column width={5}>
              <Field
                name={`${item}.allAttractions`}
                options={attractionList}
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Field
                name={`${item}.nonPrimeAdult`}
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Field
                name={`${item}.nonPrimeChild`}
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Field
                name={`${item}.primeTimeAdult`}
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Field
                name={`${item}.primeTimeChild`}
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column width={3}>
              <Button
                type="button"
                floated="left"
                negative
                onClick={() => fields.remove(index)}
              >
                X
              </Button>
            </Grid.Column>
          </Grid.Row>
        ))}
        <Grid.Row>
          <Grid.Column width={16}>
            <Button
              type="button"
              positive
              floated="left"
              onClick={() => fields.push({})}
            >
              Add More
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {(touched || submitFailed) && error && <span>{error}</span>}
    </>
  );
};

export default PerformaItemFieldArr;
